import styles from "./GuestModal.module.css";
interface SelectedGuestCountsProps {
  selectedGuestsCount: number;
}

const SelectedGuestCounts = ({ selectedGuestsCount }: SelectedGuestCountsProps) => {
  return (
    <div>
      <span className={styles["guests-info__count"]}>{`${selectedGuestsCount} guests`}</span>
    </div>
  );
};

export default SelectedGuestCounts;
